<div class="cancel-wrapper">
  @if (isLoading) {
  <div
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
    style="background: rgba(255, 255, 255, 0.6); z-index: 10"
  >
    <div class="spinner-border" role="status" aria-hidden="true"></div>
  </div>
  } @if (success !== true) {
  <div class="modern-card">
    <div class="header-minimal text-center">
      <span class="eyebrow text-uppercase">
        {{
          (isDefaultPlus
            ? "CANCEL_PAGE.TITLE_APPOINTMENT"
            : "CANCEL_PAGE.TITLE"
          ) | translate
        }}
      </span>
      <h2 class="reservation-heading mb-0">
        {{ companyName || "Sagel" }}
      </h2>
      <p class="reservation-id mb-0">
        {{
          (isDefaultPlus
            ? "CANCEL_PAGE.RESERVATION_NUMBER_APPOINTMENT"
            : "CANCEL_PAGE.RESERVATION_NUMBER"
          ) | translate
        }}: <strong>{{ reservationId }}</strong>
      </p>
    </div>
    <div class="body-content">
      <p class="intro-text">
        {{
          (isDefaultPlus
            ? "CANCEL_PAGE.INTRO_TEXT_APPOINTMENT"
            : "CANCEL_PAGE.INTRO_TEXT"
          ) | translate
        }}
      </p>
      <div class="details-card mt-3">
        <div>
          <small>{{ "CANCEL_PAGE.RESERVATION_ID" | translate }}</small>
          <span>{{ reservationId }}</span>
        </div>
        <div>
          <small>{{ "CANCEL_PAGE.COMPANY" | translate }}</small>
          <span>{{ companyName || "Sagel" }}</span>
        </div>
      </div>
      <form
        #cancelForm="ngForm"
        (ngSubmit)="onCancelClick(cancelForm)"
        novalidate
      >
        <div class="email-field">
          <label for="cancellationEmail">
            {{ "CANCEL_PAGE.EMAIL_LABEL" | translate }}
            <span aria-hidden="true">*</span>
          </label>
          <input
            id="cancellationEmail"
            #emailModel="ngModel"
            type="email"
            name="emailAddress"
            [(ngModel)]="emailAddress"
            [placeholder]="'CANCEL_PAGE.EMAIL_PLACEHOLDER' | translate"
            autocomplete="email"
            inputmode="email"
            maxlength="120"
            required
          />
          @if (!emailModel.invalid || !emailModel.touched) {
          <small class="email-hint">
            {{ "CANCEL_PAGE.EMAIL_HINT" | translate }}
          </small>
          } @if (emailModel.invalid && emailModel.touched) {
          <small class="email-error" role="alert">
            {{ "CANCEL_PAGE.EMAIL_REQUIRED" | translate }}
          </small>
          }
        </div>
        <app-altcha
          action="cancel_reservation"
          (tokenChange)="captchaToken = $event"
          (readyChange)="captchaReady = $event"
        ></app-altcha>
        <button
          type="submit"
          class="btn-cancel-modern mt-4"
          [disabled]="isLoading || !captchaReady"
        >
          <svg [cIcon]="icons.cilBan" size="lg" class="me-2"></svg>
          {{
            (isDefaultPlus
              ? "CANCEL_PAGE.BUTTON_TEXT_APPOINTMENT"
              : "CANCEL_PAGE.BUTTON_TEXT"
            ) | translate
          }}
        </button>
      </form>
    </div>
    <div class="footer-bar">
      <small class="powered-text">Powered by</small>
      <img
        src="assets/img/brand/SAGEL_LOGO.svg"
        alt="Sagel logo"
        class="powered-logo ms-2"
      />
    </div>
  </div>
  } @if (success !== null) {
  <div class="modal-overlay" role="dialog" aria-modal="true">
    <div class="modal-card" [ngClass]="success ? 'success' : 'danger'">
      <div class="modal-status-icon">
        @if (success) {
        <i class="cil-check-circle"></i>
        } @if (success === false) {
        <i class="cil-x-circle"></i>
        }
      </div>
      <h3 class="modal-title">
        {{
          success
            ? ((isDefaultPlus
                ? "CANCEL_PAGE.ALERT_SUCCESS_TITLE_APPOINTMENT"
                : "CANCEL_PAGE.ALERT_SUCCESS_TITLE"
              ) | translate)
            : ("CANCEL_PAGE.ALERT_ERROR_TITLE" | translate)
        }}
      </h3>
      <p class="modal-message">
        {{
          success
            ? ((isDefaultPlus
                ? "CANCEL_PAGE.ALERT_SUCCESS_TEXT_APPOINTMENT"
                : "CANCEL_PAGE.ALERT_SUCCESS_TEXT"
              ) | translate)
            : ("CANCEL_PAGE.ALERT_ERROR_TEXT" | translate)
        }}
      </p>
      @if (success && emailConfirmationSent === true) {
      <p class="email-status email-status--success">
        {{ "CANCEL_PAGE.EMAIL_SENT" | translate : { email: emailAddress } }}
      </p>
      } @if (success && emailConfirmationSent === false) {
      <p class="email-status email-status--error">
        {{ "CANCEL_PAGE.EMAIL_SEND_ERROR" | translate }}
      </p>
      } @if (success === false) {
      <button type="button" class="modal-action" (click)="success = null">
        OK
      </button>
      }
    </div>
  </div>
  }

  <!-- Confirm Modal -->
  @if (showConfirmModal) {
  <div class="confirm-backdrop">
    <div class="confirm-modal">
      <p>
        {{
          (isDefaultPlus
            ? "CANCEL_PAGE.CONFIRM_TEXT_APPOINTMENT"
            : "CANCEL_PAGE.CONFIRM_TEXT"
          ) | translate
        }}
      </p>
      <div class="confirm-buttons">
        <button class="btn btn-secondary" (click)="confirmCancellation(false)">
          {{ "CANCEL_PAGE.CONFIRM_NO" | translate }}
        </button>
        <button class="btn btn-danger" (click)="confirmCancellation(true)">
          {{ "CANCEL_PAGE.CONFIRM_YES" | translate }}
        </button>
      </div>
    </div>
  </div>
  }
</div>
